import Header from '../components/Header';
import Footer from '../components/Footer';

export default function MyBetsPage() {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1 mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <h1 className="font-heading text-3xl font-bold text-text-primary mb-6">My Bets</h1>
        <p className="text-text-secondary">Full my-bets implementation coming in v1-5-5.</p>
      </main>
      <Footer />
    </div>
  );
}
